import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { OrdersService } from '../../services/orders.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { EventEmitter } from '@angular/core';
import { GlobalsService } from 'app/services/globals.service';
import { CarrierTrackingService } from '../../services/carrier-tracking.service';

@Component({
	selector: 'app-order-tracking',
	templateUrl: './order-tracking.component.html',
	styleUrls: ['./order-tracking.component.scss']
})

export class OrderTrackingComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() forced_orderno: any = false;
	@Input() type: any = false;
	@Output() updated = new EventEmitter<any>();

	orderSearchRef = new UntypedFormControl('');
	trackingRef = new UntypedFormControl('');
	trackingTypeRef = new UntypedFormControl('');

	errorMessage: any = false;
	orderInfo: any = false;
	items: any = [];
	branchInfo: any = false;
	totals: any;
	searchingord: any;
	color = 'blue';
	orderno: any;
	submitting: any = false;
	forced = false;
	currentTrack: any = false;
	shippers: any = [];
	forcedType: any;

	constructor(
		private cd: ChangeDetectorRef,
		private globalsService: GlobalsService,
		private ordersService: OrdersService,
		private globalSearchService: GlobalSearchService,
		private carrierTracking: CarrierTrackingService,
	) { }

	ngAfterViewInit(): void {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.forced_orderno) {
			this.orderSearchRef.setValue(changes.forced_orderno.currentValue);
			this.orderSearch();
			this.forced = true;
		}
		if (changes.type) {
			this.forcedType = changes.type.currentValue;
			this.forced = true;
		}
	}

	ngOnInit(): void {
		this.color = this.globalSearchService.getColor();
		this.globalsService.getShipVia().subscribe((res) => {
			this.shippers = Array.isArray(res) ? res : [];
		});
	}

	setCurrentTracking(input: any): void {
		this.currentTrack = input;
		if (!this.currentTrack) {
			return;
		}
		this.trackingRef.setValue(this.currentTrack.trackingnumber);
		this.trackingTypeRef.setValue(this.currentTrack.type_id != null && this.currentTrack.type_id !== ''
			? this.currentTrack.type_id
			: '');
	}

	orderSearch(): void {
		if (this.searchingord) {
			this.searchingord = false;
		}

		const search = this.orderSearchRef.value.trim();
		if (!search.length) {
			return;
		}

		const data = {
			orderno: search
		};

		this.resetData();

		this.searchingord = this.ordersService.trackingservice(data).subscribe((res) => {
			this.searchingord = false;
			if (res.success) {
				this.orderInfo = res.orderInfo;
				this.items = res.items.details;
				this.branchInfo = res.branchInfo;
				this.totals = this.buildTotals(res.totals);
				this.orderno = res.orderInfo.orderno;
				this.currentTrack = res.orderInfo.tracking.length ? res.orderInfo.tracking[0] : false;
				if (this.currentTrack) {
					this.trackingTypeRef.setValue(this.currentTrack.type_id != null && this.currentTrack.type_id !== ''
						? this.currentTrack.type_id
						: '');
					this.trackingRef.setValue(this.currentTrack.trackingnumber);
				} else {
					this.trackingTypeRef.setValue('');
					this.trackingRef.setValue('');
				}

				if (this.forcedType) {
					this.trackingTypeRef.setValue(this.getShipperId(this.forcedType));
					this.cd.detectChanges();
				}

				this.errorMessage = false;
			} else {
				this.errorMessage = res.message || 'No data found';
			}
		});
	}

	getShipperName(track: any): string {
		if (!track) {
			return '';
		}
		if (track.shippername && (track.type_id == null || track.type_id === '' || track.type_id === undefined)) {
			return track.shippername;
		}
		if (this.shippers.length && track.type_id != null && track.type_id !== '') {
			const via = this.shippers.find((v) => String(v.shipper_id) === String(track.type_id));
			if (via) {
				return via.shippername;
			}
		}
		return track.shippername || '';
	}

	getShipperId(name: string): string {
		if (!this.shippers.length || !name) {
			return '';
		}
		const row = this.shippers.filter((via) => via.shippername.toUpperCase() === name.toUpperCase())[0];
		return row ? String(row.shipper_id) : '';
	}

	getSelectedShipperRecord(): any {
		const id = this.trackingTypeRef.value;
		return this.shippers.find((v) => String(v.shipper_id) === String(id));
	}

	getTrackingUrlForTrack(track: any): string | null {
		if (!track) {
			return null;
		}
		const via = this.shippers.find((v) => String(v.shipper_id) === String(track.type_id));
		return this.carrierTracking.getTrackingUrl(
			track.trackingnumber,
			this.getShipperName(track),
			track.url,
			via?.url,
		);
	}

	getCurrentResolvedTrackingUrl(): string | null {
		return this.getTrackingUrlForTrack(this.currentTrack);
	}

	isTrackingTypeChanged(): boolean {
		if (!this.currentTrack) {
			return false;
		}
		const cur = this.currentTrack.type_id != null && this.currentTrack.type_id !== ''
			? String(this.currentTrack.type_id)
			: '';
		return String(this.trackingTypeRef.value || '') !== cur;
	}

	buildTotals(input: any): any[] {
		const out: any[] = [];
		const allowed = ['total'];
		Object.keys(input).forEach((k) => {
			if (allowed.includes(k)) {
				out.push({
					code: k,
					text: input[k]
				});
			}
		});
		return out;
	}

	resetData(): void {
		this.orderInfo = false;
		this.items = [];
		this.branchInfo = false;
		this.totals = false;
		this.orderno = false;
	}

	submitTracking(type: string): void {
		let update = false;
		let submit = true;
		let remove = false;
		let message = 'Tracking Number Submitted';

		if (type === 'update') {
			update = true;
			submit = false;
			message = 'Tracking Number Updated';
		}

		if (type === 'remove') {
			update = submit = false;
			remove = true;
			message = 'Tracking Number Removed';
			if (!confirm('Remove tracking number from this order?')) {
				this.trackingRef.setValue('');
				return;
			}
		}

		const via = this.getSelectedShipperRecord();
		const shipperLabel = via ? via.shippername : this.getShipperName(this.currentTrack);
		const derivedUrl = this.carrierTracking.getTrackingUrl(
			this.trackingRef.value.trim(),
			shipperLabel,
			null,
			via?.url,
		) || '';

		const data: any = {
			tracking: this.trackingRef.value.trim(),
			orderno: this.orderSearchRef.value.trim(),
			originaltrack: this.currentTrack,
			submit: submit,
			update: update,
			remove: remove,
			tracktype: this.trackingTypeRef.value,
			url: derivedUrl,
		};

		this.submitting = true;
		this.submitting = this.ordersService.trackingservice(data).subscribe((res) => {
			if (res.success) {
				this.orderInfo = res.orderInfo;
				this.items = res.items.details;
				this.branchInfo = res.branchInfo;
				this.totals = this.buildTotals(res.totals);
				this.orderno = res.orderInfo.orderno;
				this.errorMessage = false;

				if (res.orderInfo.tracking?.length && type !== 'remove') {
					const match = res.orderInfo.tracking.filter((i: any) =>
						i.trackingnumber === data.tracking
					)[0];
					this.setCurrentTracking(match);
				}

				if (type === 'remove') {
					if (res.orderInfo.tracking?.length) {
						this.setCurrentTracking(res.orderInfo.tracking[res.orderInfo.tracking.length - 1]);
					} else {
						this.currentTrack = false;
					}
				}

				if (this.currentTrack) {
					this.trackingRef.setValue(this.currentTrack.trackingnumber);
				}
				this.globalSearchService.showNotification(message, 'success', 'bottom', 'left');
				if (this.forced) {
					this.updated.emit(null);
				}
			} else {
				this.globalSearchService.showNotification('Tacking Number already present', 'warning', 'bottom', 'left');
			}
			this.submitting = false;
		});
	}
}
